/* eslint-disable */
<template>
  <v-container fluid class="experience">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" sm="4">
            <div><h3>Work Experience</h3></div>
          </v-col>
          <v-col cols="12" md="8" sm="8" class="text-right">
            <v-btn
              color="primary"
              class="workexp--button"
              link
              :to="{ name: 'ExperienceCard' }"
            >
              <v-icon class="mx-2"> add </v-icon>
              Add Work Experience
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-5">
      <v-data-table
        id="scollStyle"
        ref="academic_list"
        :headers="headers"
        :items="experience"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        multi-sort
        class="elevation-0"
      >
        <!--eslint-disable-next-line -->
      <template v-slot:item.fromDate="{ item }">
          <div>{{ formatDate(item.fromDate) }}</div>
        </template>
        <!--eslint-disable-next-line -->
      <template v-slot:item.toDate="{ item }">
          <div>{{ formatDate(item.toDate) }}</div>
        </template>
        <!--BEGIN actions buttons-->
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize links"
                text
                v-bind="attrs"
                v-on="on"
                small
                ><v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="{
                  name: 'ExperienceCard',
                  query: { edit: `${item.lineNo}` },
                }"
              >
                <v-icon color="blue darken-4">mode_edit</v-icon> Edit
              </v-list-item>
              <v-divider />
              <v-list-item @click="deleteWorkExp(item)">
                <v-icon color="red">delete</v-icon> Delete
              </v-list-item>
              <v-divider />
            </v-list>
          </v-menu>
        </template>
        <!--END actions buttons-->
      </v-data-table>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          class="mx-2 contacts--button"
          color="error"
          text
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          Back
        </v-btn>
        <v-btn
          class="mx-2 contacts--button"
          outlined
          color="primary"
          :to="{ name: 'Referee' }"
        >
          Next
          <v-icon class="mx-2"> arrow_forward </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import helpers from "../../../dashboard/utils/helpers/helper.js";
export default {
  name: "ExperienceComponent",
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.document.title = "KISEB::Experience Profile";
    });
  },
  data: function () {
    return {
      sortBy: "lineNo",
      sortDesc: true,
    };
  },
  computed: {
    experience() {
      return this.$store.getters["Profile/experienceGetters"]("workexp");
    },
    headers() {
      return [
        {
          text: "#S/N",
          align: "start",
          sortable: true,
          value: "lineNo",
        },
        { text: "From Date", sortable: true, value: "fromDate" },
        { text: "To Date", sortable: true, value: "toDate" },
        { text: "Company", sortable: true, value: "nameOfFirm" },
        { text: "Role", sortable: true, value: "positionHeld" },
        { text: "Sector", sortable: true, value: "sector" },
        {
          text: "Job Description",
          sortable: true,
          value: "responsibilitiesDescription",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    deleteWorkExp(data) {
      this.$store.dispatch("Profile/deleteexperience", { ...data });
    },
    formatDate(date) {
      return helpers.getDateFormat(date);
    },
  },
};
</script>

<style scoped>
@import url("./styles.css");
</style>
